import { gql } from "@apollo/client";

export const GET_WATERUSE_YEARS_AND_SOURCES = gql`
  query GetWaterSystemWaterUseYearsAndSources($pwsId: String!) {
    getWaterSystemWaterUseYearsAndSources(pwsId: $pwsId) {
      years
      sources {
        id
        name
      }
    }
  }
`;
